
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/whitepaper/[id]",
      function () {
        return require("private-next-pages/whitepaper/[id].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/whitepaper/[id]"])
      });
    }
  